import ThemeFilterFormDrawer from 'assets/components/filters/filterForm/themes/Theme.FilterForm.Drawer';
import { usePayeeTypeProvider } from '../PayeeType.Hooks';
import FilterForm from 'assets/components/filters/filterForm/FilterForm';

export default function PayeeTypeFilters() {
  const { listApi } = usePayeeTypeProvider();

  return (
    <FilterForm
      subcomponents={ThemeFilterFormDrawer}
      search={listApi.body?.search}
      onSearch={(search) => listApi.execute((body) => ({ ...body, search, offset: 0 }))}
      onSortById={(sort) => listApi.execute((body) => ({ ...body, ...sort }))}
      filters={listApi.body}
      onFilter={(newFilers) => listApi.execute({ ...newFilers, offset: 0 })}
      onReset={listApi.reset}
    />
  );
}
